import { QueryClient } from '@tanstack/react-query';

// One server-state cache for the app. staleTime keeps gallery -> open -> back
// instant (cached data is served without a refetch for 5 minutes). In tests we
// disable retry so a rejected queryFn surfaces immediately, and zero cacheTime so
// inactive queries are GC'd immediately and schedule no timer (otherwise the v4
// cache-GC timer keeps Jest from exiting cleanly).
export function makeQueryClient({ test = false } = {}) {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: test ? false : 2,
        cacheTime: test ? 0 : 5 * 60 * 1000,
      },
    },
  });
}

export const queryClient = makeQueryClient();
